import ProductList from "../../../components/AdminComponents/Products";

const Products = () => {
  return (
    <div className="flex h-full">
      <ProductList />
    </div>
  );
};

export default Products;
